import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Partner } from '../../models/partner';
import { faPen } from '@fortawesome/free-solid-svg-icons';


@Component({
  selector: 'app-children-list',
  templateUrl: './children-list.component.html',
  styleUrls: ['./children-list.component.css']
})
export class ChildrenListComponent implements OnInit {

  @Input()
  children: Partner[];

  @Output() eventListItemClicked = new EventEmitter<Partner>();

  faPen = faPen;

  constructor() { }

  ngOnInit() {
  }

  listItemClicked(child: Partner) {
    this.eventListItemClicked.emit(child);
  }

  formatListItemTitle(child: Partner): string {
    return child ? `${child.firstName}, ${child.age}` : '';
  }

  truncateLinkButton(child: Partner): string {
    return child ? `${child.firstName}` : '';
  }

  titleLinkButton(child: Partner): string {
    return child ? `, ${child.age}` : '';
  }
}
